import { fork, all } from 'redux-saga/effects';

import * as updatePrices from './updatePrices';

export default function* rootSaga() {
  yield all([...Object.values(updatePrices)].map(fork));
}
